export interface iStickyScrollPositionHelper {
  preserveScrollPosition:number,
  // eslint-disable-next-line no-unused-vars
  preservePositionOnce:(element:HTMLElement) => void,
  allowFocus:() => void,
  // eslint-disable-next-line no-unused-vars
  setScrollPosition:(element:HTMLElement) => void,
  resetScrollPosition:() => void,
}

class StickyScrollPositionHelper implements iStickyScrollPositionHelper {
  preserveScrollPosition = -1;

  preservePositionOnce = (element:HTMLElement) => {
    this.preserveScrollPosition = element.scrollTop;
  }

  allowFocus = () => this.preserveScrollPosition === -1

  setScrollPosition = (element:HTMLElement) => {
    if (this.preserveScrollPosition === -1) return;

    element.scrollTop = this.preserveScrollPosition;
  }

  resetScrollPosition = () => {
    this.preserveScrollPosition = -1;
  }
}

export default new StickyScrollPositionHelper();
